import { render, staticRenderFns } from "./ead-curso-card.vue?vue&type=template&id=db1500ae&scoped=true&"
import script from "./ead-curso-card.vue?vue&type=script&lang=js&"
export * from "./ead-curso-card.vue?vue&type=script&lang=js&"
import style0 from "./ead-curso-card.vue?vue&type=style&index=0&id=db1500ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1500ae",
  null
  
)

export default component.exports